<template>
  <Carousel v-bind="settings" class="">
    <Slide v-for="(item, index) in productData" :key="index">
      <div
        class="flex flex-col justify-between gap-2 mr-2 p-2 border border-gray-200 rounded-lg shadow-md bg-white w-full cursor-pointer"
        @click="handleNavigate(item.sku_id)" :style="isDark ? {
          backgroundColor: `${items?.style?.slotBgColorDark ? items?.style?.slotBgColorDark : '#FFFFFF'}`,
        } : { backgroundColor: `${items?.style?.slotBgColor ? items?.style?.slotBgColor : '#FFFFFF'}`, }">
        <!-- <div
        class="flex flex-col justify-between gap-2 mr-4 p-2 border border-gray-200 rounded-lg shadow-md bg-white w-full cursor-pointer"
        @click="useBannerAction(item, items.header)"
      > -->
        <!-- Free Delivery Badge -->
        <div class="flex justify-start">
          <!-- <span
            class="bg-yellow-100 text-yellow-800 text-xs font-semibold px-2 py-1 rounded-full"
          >
            Free Delivery
          </span> -->
        </div>
        <!-- Product Image -->
        <div class="flex justify-center items-center overflow-hidden h-32">
          <img :src="item?.images?.thumbnail
            ? item?.images?.thumbnail
            : 'https://nstore-static-data-s3.s3.ap-south-1.amazonaws.com/Logo/tmp_product_image.jpeg'
            "
            @error="onImageError($event)"
            class="object-contain h-full"
            :alt="item?.name || 'Product image'"
            :title="item?.name || 'Product image'"
          />
        </div>

        <!-- Title and Subtitle -->
        <div class="flex flex-col items-start mt-2 px-1">
          <h5
            :class="items?.style?.slotTitleColor ? 'text-sm font-bold line-clamp-1' : 'text-sm font-bold text-gray-900 line-clamp-1'"
            :style="isDark ? {
              color: `${items?.style?.slotTitleColorDark ? items?.style?.slotTitleColorDark : '#000000'}`,
            } : { color: `${items?.style?.slotTitleColor ? items?.style?.slotTitleColor : '#000000'}` }">
            {{ item?.name }}
          </h5>
          <p :class="items?.style?.slotSubtitleColor ? 'text-xs line-clamp-1' : 'text-xs text-gray-500 line-clamp-1'"
            :style="isDark ? {
              color: `${items?.style?.slotSubtitleColorDark ? items?.style?.slotSubtitleColorDark : '#000000'}`,
            } : { color: `${items?.style?.slotSubtitleColor ? items?.style?.slotSubtitleColor : '#000000'}`, }">
            by {{ item?.provider?.name }}
          </p>
        </div>

        <!-- Time, Distance, Price and Add Button -->
        <div class="flex flex-col gap-1 mt-2">
          <!-- <div class="flex items-center text-green-600 text-xs gap-1">
            <span>⚡</span>
            <span>24 mins • 1.2 km</span>
          </div> -->

          <div :class="isMobile ? 'items-center mt-1' : 'flex justify-between items-center mt-1'">
            <div>
              <span
                :class="items?.style?.slotTitleColor ? 'text-sm font-bold mr-2' : 'text-sm font-bold text-gray-900 mr-2'"
                :style="{
                  color: `${items?.style?.slotTitleColor ? items?.style?.slotTitleColor : '#000000'}`,
                }">₹{{ item.price }}</span>
              <span v-if="item?.discountPercentage" class='text-sm font-bold text-gray-500 line-through'>₹{{
                item.max_price }}</span>
            </div>
            <div :class="isMobile ? 'flex items-center min-h-[20px]' : 'flex items-center'">
              <img v-if="item?.discountPercentage" src="@/public/v1/icons/percentage.png" alt="Discount percentage icon" title="Discount available on this product" class="w-4 h-4 text-orange-500" />
              <span class='text-sm discountColor'>{{
                item?.discountPercentage ? `${item.discountPercentage}% off` : '' }}</span>
            </div>
          </div>
          <V3CartButtonComponent size="sm" :product="item" label="Add To Cart" :disabled="item.is_stock_available" />
        </div>
      </div>
    </Slide>
  </Carousel>
</template>

<script setup>
const props = defineProps(["items", "config", "layout", "size"]);
const { isMobile } = useDevice();
const productData = ref([]);
const isDark = ref(false);
let mediaQuery
let handleSchemeChange

function onImageError(event) {
  event.target.src =
    "https://nstore-static-data-s3.s3.ap-south-1.amazonaws.com/Logo/tmp_product_image.jpeg";
}


onMounted(() => {
  /* Dark mode disabled:
  mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
  isDark.value = mediaQuery.matches

  handleSchemeChange = (e) => {
    isDark.value = e.matches
    console.log(`User switched to ${isDark.value ? 'dark' : 'light'} mode`)
  }

  mediaQuery.addEventListener('change', handleSchemeChange)
  */
})

onBeforeUnmount(() => {
  /* Dark mode cleanup disabled:
  if (mediaQuery && handleSchemeChange) {
    mediaQuery.removeEventListener('change', handleSchemeChange)
  }
  */
});

async function getAllBanners() {
  try {
    let ids = props.items.banners.map((x) => {
      return x.productData.skuId;
    });
    const data = await useAPIHandler("get", "/cms/product_banners", {
      query: {
        skuId: ids,
      },
    });
    productData.value = [];
    for (let i = 0; i < props.items.banners.length; i++) {
      for (let j = 0; j < data.data.length; j++) {
        if (props.items.banners[i].productData.skuId == data.data[j].sku_id) {
          if (data.data[j].price !== data.data[j].max_price && data.data[j].max_price != 0 && data.data[j].max_price > data.data[j].price) {
            let percentage = ((data.data[j].max_price - data.data[j].price) / data.data[j].max_price) * 100
            Object.assign(data.data[j], { discountPercentage: percentage.toFixed(0) })
          }
          productData.value.push(data.data[j]);
        }
      }
    }

    // productData.value = data.data;
  } catch (error) {
    console.log(error);
  }
}

async function handleNavigate(id) {
  navigateTo({ path: `/products/${id}` });
}
onMounted(() => {
  getAllBanners();
});

const isSquare = props.layout === "square";
const isLarge = props.size && props.size === "max";

const sizeClasses = isMobile
  ? isLarge
    ? "h-40"
    : "h-32"
  : isLarge
    ? "h-48"
    : "h-40";
const roundedClasses = isSquare ? "rounded-md" : "rounded-full";
const borderClasses = props.config.border ? "border border-stone-200" : "";
const classes = [
  "object-contain",
  ...sizeClasses,
  ...roundedClasses,
  ...borderClasses,
];

const mobileItems = isLarge ? 2.75 : 2.35;
const desktopItems = isLarge ? 4.95 : 6.55;
const squareMobileItems = isLarge ? 2.75 : 2.35;
const squareDesktopItems = isLarge ? 4.95 : 6.55;

const itemsToShow = ref(isMobile ? squareMobileItems : squareDesktopItems);
if (!isSquare) {
  itemsToShow.value = isMobile ? mobileItems : desktopItems;
}

const settings = {
  itemsToShow: itemsToShow.value,
  snapAlign: "start",
};
</script>
<style>
.discountColor {
  color: #1778eb
}
</style>
